/**
 * GateManagement Repository
 * 게이트 관리 API 호출
 */
import { API_BASE_URL } from '../../../config/api';
import { Gate, NewGateData } from '../models/GateManagement';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export class GateManagementRepository {
  /**
   * 게이트 목록 조회
   */
  async getGates(): Promise<Gate[]> {
    const response = await fetch(`${API_BASE_URL}/v1/gates`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('게이트 목록을 불러올 수 없습니다');
    }

    return await response.json();
  }

  /**
   * 게이트 추가
   */
  async createGate(gateData: NewGateData): Promise<Gate> {
    const response = await fetch(`${API_BASE_URL}/v1/gates`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(gateData),
    });

    if (!response.ok) {
      throw new Error('게이트 추가 실패');
    }

    return await response.json();
  }

  /**
   * 게이트 삭제
   */
  async deleteGate(gateId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/v1/gates/${gateId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('게이트 삭제 실패');
    }
  }

  /**
   * 게이트 토큰 생성
   */
  async generateGateToken(gateId: string): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/v1/gates/${gateId}/token`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('게이트 토큰 생성 실패');
    }

    const data = await response.json();
    return data.token;
  }

  /**
   * 게이트 알림 설정 업데이트
   */
  async updateAlertSettings(
    gateId: string,
    settings: { sendParentAlert: boolean; countForStudyTime: boolean }
  ): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/v1/gates/${gateId}/alert-settings`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      throw new Error('알림 설정 업데이트 실패');
    }
  }
}

export const gateManagementRepository = new GateManagementRepository();
